// extracted by mini-css-extract-plugin
export default {"container":"Login_container__e6nYi","form":"Login_form__cgvJo","signup":"Login_signup__95ZXH","google":"Login_google__KFCwF"};